import { inject, Injectable } from '@angular/core';
import { from, map, Observable } from 'rxjs';
import {
  SmsGatewaysApi,
  CreateOrUpdateSmsGateway,
  SmsGateway,
  PatchSmsGateway,
  SmsReportApi,
  SmsReportList,
  QuerySmsReportRequest,
  TestSmsGatewayResponse,
} from '@tourfold/libraries/tf-api-client-public-v2';

@Injectable({
  providedIn: 'root',
})
export class SmsGatewayService {
  private readonly smsGatewaysApi: SmsGatewaysApi = inject(SmsGatewaysApi);
  private readonly smsReportApi: SmsReportApi = inject(SmsReportApi);

  listGateways(): Observable<SmsGateway[]> {
    return from(this.smsGatewaysApi.listGateways()).pipe(
      map((response) => response.items ?? [])
    );
  }

  createGateway(createOrUpdateSmsGateway: CreateOrUpdateSmsGateway): Observable<SmsGateway> {
    return from(
      this.smsGatewaysApi.createGateway({
        createOrUpdateSmsGateway,
      })
    );
  }

  replaceGateway(id: string, createOrUpdateSmsGateway: CreateOrUpdateSmsGateway): Observable<SmsGateway> {
    return from(
      this.smsGatewaysApi.replaceGateway({
        id,
        createOrUpdateSmsGateway,
      })
    );
  }

  deleteGateway(id: string): Observable<void> {
    return from(
      this.smsGatewaysApi._delete({
        id,
      })
    );
  }

  reorderGateways(gatewayIds: string[]): Observable<void> {
    return from(
      this.smsGatewaysApi.reorder({
        reorderSmsGateways: {
          gatewayIds,
        },
      })
    );
  }

  toggleGateway(id: string, enabled: boolean): Observable<SmsGateway> {
    const patchSmsGateway: PatchSmsGateway = { enabled };
    return from(
      this.smsGatewaysApi.patchGateway({
        id,
        patchSmsGateway,
      })
    );
  }

  testGateway(id: string, phoneNumber: string): Observable<TestSmsGatewayResponse> {
    return from(
      this.smsGatewaysApi.sendTest({
        id,
        testSmsGateway: {
          phoneNumber,
        },
      })
    );
  }

  querySmsReport(request: QuerySmsReportRequest): Observable<SmsReportList> {
    return from(this.smsReportApi.querySmsReport(request));
  }
}
